// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';

import EditableMulti from '../EditableMulti';
import Checkbox from '../Checkbox';
import Modal from './Modal';

const providerIcons = {
    "Gmail": "gmail.png",
    "Office365": "outlook.png",
    "Exchange": "exchange.png",
    "IMAP": "host.png",
    "Yahoo": "yahoo.png"
};

export default class ConfigureEmail extends Modal {

    renderContent = () => {

        const cfg = this.props.accounts && this.props.data && typeof this.props.data.accountIdx === "number" && this.props.accounts.length > this.props.data.accountIdx ? this.props.accounts[this.props.data.accountIdx] : {};

        return (<div className="modal-content modal-center">

            <h1>
                <img
                    style={{
                        width: 48,
                        height: 48,
                        marginBottom: -14,
                        marginRight: 10
                    }}
                    alt={cfg.provider}
                    src={"https://static.stax.ai/images/mail/" + (cfg.host === "imap.mail.yahoo.com" ? "yahoo.png" : providerIcons[cfg.provider])}
                />
                {cfg.email}
            </h1>
            <p>Stax·ai automatically checks your email and pulls any document-like attachments (PDFs, Word documents, etc.) into your Stax·ai account. To specify an rules or filters that decide which emails or attachment files to intake, specify them below.</p>

            <h2>Intake Configuration</h2>

            <div style={{
                width: 720,
                margin: '0 auto',
                paddingTop: 10
            }}>
                <Checkbox
                    label={"Move emails to a separate folder (called \"Stax·ai\") after importing them into Stax·ai."}
                    checked={cfg.provider === "IMAP" || cfg.moveEmails}
                    onToggle={() => {
                        if (cfg.provider === "IMAP")
                            return toast.info("Currently, IMAP emails need to be moved to a separate folder after checking them to avoid duplicate intake.");

                        this.props.updateEmailConfig({
                            moveEmails: !cfg.moveEmails
                        });
                    }}
                />

                <Checkbox
                    label="Save all email threads as a searchable document in Stax·ai along with attachments.."
                    checked={cfg.saveEmail}
                    onToggle={() => this.props.updateEmailConfig({
                        saveEmail: !cfg.saveEmail
                    })}
                />

                {cfg.saveEmail ? <>
                    <Checkbox
                        label={"Attach file to email thread document instead of saving as separate documents."}
                        checked={cfg.attachOnly}
                        onToggle={() => this.props.updateEmailConfig({
                            attachOnly: !cfg.attachOnly
                        })}
                    />
                    <p className="checkbox-hint">
                        If you attach files to the email thread document instead of saving them as spearate documents, they will not be searchable.
                    </p>
                </> : ""}

                <label>Which file formats should Stax·ai intake?</label>
                <EditableMulti
                    hideMenu={true}
                    placeholder="Example: pdf, docx, xlsx..."
                    value={cfg.formats ? cfg.formats.map(extn => ({
                        value: extn,
                        label: extn
                    })) : []}
                    onChange={(value) => this.props.updateEmailConfig({
                        formats: value ? value.map(v => v.value) : []
                    })}
                />

                <h2>Email Whitelist Filters</h2>
                <label>Match atleast one pattern in sender email:</label>
                <EditableMulti
                    hideMenu={true}
                    placeholder="Example: stax.ai, support@stax.ai ..."
                    value={cfg.filters && cfg.filters.from ? cfg.filters.from.map(pattern => ({
                        value: pattern,
                        label: pattern
                    })) : []}
                    onChange={(value) => this.props.updateEmailConfig({
                        filters: {
                            ...cfg.filters,
                            from: value ? value.map(v => v.value) : []
                        }
                    })}
                />

                <label style={{ clear: 'both', marginTop: 15 }}>Match atleast one pattern in email subject:</label>
                <EditableMulti
                    hideMenu={true}
                    placeholder="Example: Registration Form ..."
                    value={cfg.filters && cfg.filters.subject ? cfg.filters.subject.map(pattern => ({
                        value: pattern,
                        label: pattern
                    })) : []}
                    onChange={(value) => this.props.updateEmailConfig({
                        filters: {
                            ...cfg.filters,
                            subject: value ? value.map(v => v.value) : []
                        }
                    })}
                />

                <div style={{ clear: 'both', marginTop: 20 }} />

                <div
                    className="button"
                    style={{
                        float: 'none',
                        backgroundImage: "url('https://static.stax.ai/images/icons/reviewed.png')"
                    }}
                    onClick={() => this.props.modal()}
                >Save changes & close</div>

                <br /><br /><br />

            </div>
            
        </div>);
    }

};